import { upsertUser, upsertDevice, getDevice } from '../utils/local-db';
import { sha256, base64urlToBuffer, verifyP256Signature } from '../utils/crypto';

export async function registerDeviceLocal(payload: { walletId: string; deviceId: string; label: string; publicKeySpki?: string | null }) {
  await upsertUser({ walletId: payload.walletId, createdAt: Date.now() });
  await upsertDevice({ id: payload.deviceId, walletId: payload.walletId, label: payload.label || 'Device', publicKeySpki: payload.publicKeySpki || null, createdAt: Date.now() });
  return { ok: true };
}

export async function beginTxLocal(tx: { txId: string; to: string; amount: number; nonce: number; timestamp: number }) {
  const txMsg = JSON.stringify(tx);
  const challenge = await sha256(txMsg);
  return { challenge };
}

export async function verifyTxLocal(args: { deviceId: string; response: { authenticatorData: string; clientDataJSON: string; signature: string } }) {
  const device = await getDevice(args.deviceId);
  if (!device || !device.publicKeySpki) throw new Error('Unauthorized device');
  const authData = base64urlToBuffer(args.response.authenticatorData);
  const clientData = base64urlToBuffer(args.response.clientDataJSON);
  const clientHash = await crypto.subtle.digest('SHA-256', clientData);
  const dataToVerify = new Uint8Array(authData.byteLength + clientHash.byteLength);
  dataToVerify.set(new Uint8Array(authData), 0);
  dataToVerify.set(new Uint8Array(clientHash), new Uint8Array(authData).byteLength);
  const ok = await verifyP256Signature(device.publicKeySpki, dataToVerify, args.response.signature);
  if (!ok) throw new Error('Signature invalid');
  return { ok: true };
}

export async function recoverWalletLocal(approvals: Array<{ deviceId: string }>) {
  if (!Array.isArray(approvals) || approvals.length < 2) throw new Error('Need 2 approvals');
  return { ok: true };
}


